<template lang="pug">
.v-instruction-content.instruction
	.instruction__header.flc(v-if="title")
		//- иконка встроена, а не из спрайта — см. комментарий в v-instruction.vue
		span.instruction__header-icon.flc
			svg.instruction__header-icon-svg(viewBox="0 0 24 24" aria-hidden="true" focusable="false")
				circle(cx="12" cy="12" r="10.4" fill="none" stroke="currentColor" stroke-width="1.6")
				path(fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
						d="M9.25 9.6a2.75 2.75 0 1 1 3.35 2.68c-.37.12-.6.47-.6.86v1.2")
				circle(cx="12" cy="17.05" r="1.15" fill="currentColor")
		.instruction__header-title {{ title }}
	.instruction__body(v-html="html")
</template>

<script>
/**
 * Содержимое окна инструкции. Рисуется внутри общего v-modal-window
 * (заголовок с крестиком даёт он), см. scripts/helpers/instruction.js.
 *
 * html — фрагмент из local/include/<lang>/personal/instructions/<code>.php,
 * заказчик правит его из админки. Оформление опирается на классы
 * instruction__lead / instruction__step / instruction__attention (instruction.scss);
 * если в тексте их нет, он выведется обычными абзацами.
 */
export default {
	props: {
		title: {
			type: String,
			default: ''
		},

		html: {
			type: String,
			default: ''
		}
	}
};
</script>
